import React from 'react';
import { Linking, Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { PRIVACY_POLICY_PATH, SIGNUP_CONSENT_LABEL, } from '@shared/signup/consent';
import { theme } from '../theme';
export const openPrivacyPolicy = () => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
        window.open(PRIVACY_POLICY_PATH, '_blank', 'noopener,noreferrer');
        return;
    }
    Linking.openURL(`https://app.abbisway.com${PRIVACY_POLICY_PATH}`);
};
/** Required consent shown only on public sign-up (not admin Add/Edit). */
export const SignupConsentCheckbox = ({ checked, onChange, showError, }) => (<View style={styles.container}>
    <Pressable testID="signup-consent-checkbox" accessibilityRole="checkbox" accessibilityState={{ checked }} accessibilityLabel={SIGNUP_CONSENT_LABEL} onPress={() => onChange(!checked)} style={styles.row}>
      <View style={[styles.box, checked && styles.boxChecked]}>
        {checked ? <Text style={styles.check}>✓</Text> : null}
      </View>
      <Text style={styles.label}>{SIGNUP_CONSENT_LABEL}</Text>
    </Pressable>
    <Pressable accessibilityRole="link" onPress={openPrivacyPolicy} style={styles.linkRow}>
      <Text style={styles.link}>Read the privacy policy</Text>
    </Pressable>
    {showError && !checked ? (<Text style={styles.error}>
        Please agree to the privacy policy to continue.
      </Text>) : null}
  </View>);
const styles = StyleSheet.create({
    container: { marginHorizontal: 16, marginTop: 16 },
    row: { flexDirection: 'row', alignItems: 'flex-start', minHeight: 44 },
    box: {
        width: 24,
        height: 24,
        borderWidth: 2,
        borderRadius: 4,
        borderColor: theme.colors.textSecondary,
        marginRight: 12,
        marginTop: 2,
        alignItems: 'center',
        justifyContent: 'center',
    },
    boxChecked: {
        backgroundColor: theme.colors.link,
        borderColor: theme.colors.link,
    },
    check: { color: '#FFFFFF', fontWeight: '700' },
    label: { flex: 1, fontSize: 15, lineHeight: 20, color: theme.colors.textPrimary },
    linkRow: { marginLeft: 36, paddingVertical: 8 },
    link: {
        fontSize: 15,
        color: theme.colors.link,
        textDecorationLine: 'underline',
    },
    error: { marginLeft: 36, fontSize: 14, color: theme.colors.dangerText },
});
